import { loadStripe } from "@stripe/stripe-js";
import { apiRequest } from "./api/util";
import { getStripePriceId } from "./prices";

let stripe;
// Load the Stripe script
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLIC_KEY
).then((stripeInstance) => {
  // Set stripe so all functions below have it in scope
  stripe = stripeInstance;
  return stripe;
});

export async function redirectToCheckout(planId, metadata={}) {
  // Create a checkout session
  console.log("planId", getStripePriceId(planId))
  console.log("metadata: ", metadata)
  const session = await apiRequest("app/partner-create-checkout-session", "POST", {
    priceId: getStripePriceId(planId),
    metadata: metadata
  });

  if (session.redirect_url) {
    window.location.href = session.redirect_url
    return
  }

  // Ensure if user clicks browser back button from checkout they go to /pricing
  // instead of this page or they'll redirect right back to checkout.
  window.history.replaceState({}, "", "/build?path=dashboard/settings&hash=my-plan");

  // Redirect to checkout
  return stripe.redirectToCheckout({
    sessionId: session.id
  });
}

export async function redirectToBilling() {
  // Create a billing session
  const session = await apiRequest("app/partner-create-billing-session", "POST");

  // Redirect to billing session url
  window.location.href = session.url;
}


